import { Label } from "@hopper/legacy_label";
import { Button } from "@hopper/button";
import React from "react";
import { Test } from "components/flexible_testing/tests_for_cloning_page/tests_list/use_tests";
import { CloneLink } from "components/flexible_testing/shared/clone_link/clone_link";

type TestsListItemProps = {
  test: Test;
  trackingEventName: string;
};

function TestsListItem({ test, trackingEventName }: TestsListItemProps): JSX.Element {
  const { _id, code, name, date, isClosed } = test;

  return (
    <div data-testid="test-list-item" className="border-b border-light grid grid-cols-6 gap-xl items-center">
      <span className="py-md col-span-4" data-testid="test-list-item-name">
        <div className="uppercase text-secondary tracking-wide text-sm">{code}</div>
        <div className="truncate whitespace-nowrap font-bold mb-xs">{name}</div>
        <span className="tracking-wide uppercase text-xs text-secondary font-bold">
          {isClosed ? (
            <span className="mr-sm uppercase">finished</span>
          ) : (
            <Label className="ml-0 mr-sm uppercase" color="bg-primary">
              live
            </Label>
          )}

          {date}
        </span>
      </span>
      <span className="py-md col-span-2 flex justify-end" data-testid="test-list-item-clone-action">
        <CloneLink
          trackingEventName={trackingEventName}
          testTrackingId={_id}
          pathForCloning={test.pathForCloning}
          testId={test.id}
        >
          <Button variant="secondary" size="sm">
            Clone
          </Button>
        </CloneLink>
      </span>
    </div>
  );
}

export default TestsListItem;
